export enum AdminRequireActionTransactionsColumns {
  CREATED_AT = "created_at",
  ID = "id",
  TYPE = "type_id",
  PAYMENT_SERVICE = "external_service_type_id",
  BANK_ACCOUNT = "bank_account",
  FROM_ACCOUNT = "from_account",
  TO_ACCOUNT = "to_account",
  REMITTER_NAME = "remitter_name",
  BENEFICIARY_NAME = "beneficiary_name",
  STATUS = "readable_status",
  AMOUNT = "amount",
  SOURCE_REFERENCE = "source_reference",
  BALANCE = "balance",
  FEE_DESCRIPTION = "fee_description",
  FEE_RELATED_TRANSACTION = "fee_related_transaction",
  REFERENCE_MESSAGE = "ref_message",
  ACTIONS = "actions",
}

export const all = Object.keys(AdminRequireActionTransactionsColumns).filter(
  (item) => {
    return isNaN(Number(item));
  }
);
